// 회사(테넌트) 레지스트 — id·이름·전화·시나리오의 단일 출처.
//
// id 는 서버 `company.id` 와 같은 값이되 **문자열로 통일**한다.
// 하위 라우터(ChatRouter/CloseRouter/RatingRouter/ExpiredRouter)와 Loading 이
// 쿠키에서 읽은 값으로 문자열 비교 분기를 하기 때문.
//
// name 은 화면 표기명. 서버 응답(companyStore)이 오기 전 즉시 렌더할 기본값이자
// 응답이 없을 때의 fallback 이다. 서버 값과 다를 수 있다 — 예: id 17 은
// 서버상 '대신증권' 이지만 화면 표기는 '퀀텀증권'.

export const COMPANY = {
  BTB: {
    id: '7',
    key: 'btb',
    name: '한국비티비',
    tel: '02-4362-5400',
  },
  QV: {
    id: '15',
    key: 'qv',
    name: '한국의약품안전관리원',
    tel: '02-2172-6700',
    sid: 'SID1001',
    teamId: 19,
  },
  DAISHIN: {
    id: '17',
    key: 'daishin',
    name: '퀀텀증권',
    tel: '1588-4488',
  },
  HYUNDAIRS: {
    id: '35',
    key: 'hyundairs',
    name: '현대렌탈서비스',
    tel: '1588-5897',
  },
};
